// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__wFaAH","opacity-transition":"success_opacity-transition__kj7YO"};